import { render, staticRenderFns } from "./RefundDeliveryDetail.vue?vue&type=template&id=6b5a6be0&"
import script from "./RefundDeliveryDetail.vue?vue&type=script&lang=js&"
export * from "./RefundDeliveryDetail.vue?vue&type=script&lang=js&"
import style0 from "./RefundDeliveryDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports